export const THRESHOLD_DESKTOP_WIDTH = 1200
export const THRESHOLD_SP_WIDTH = 680
